import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import {
  NavigationSide,
  NavigationSideItem,
  viStore,
  viActivityFeed,
  viAlert,
  viCloseCircle,
  viFolder,
} from 'vibeguide';

function LocationNavigation({
  user,
  className,
}) {
  return (
    <NavigationSide className={classNames('LocationNavigation', className)}>
      <NavigationSideItem
        text="Basic Info"
        url="/locations"
        icon={viStore}
        show={user.can('location.view')}
        testId="location-nav-basic-info"
      />

      <NavigationSideItem
        text="Integration Location Files"
        url="/integration/files"
        icon={viFolder}
        show={user.can('location_control_file.view')}
        testId="location-nav-integration-files"
      />

      <NavigationSideItem
        text="Support Dashboard"
        url="/dashboard/support"
        icon={viActivityFeed}
        show={user.can([
          'admin.system_admin',
          'location.view_telemetry',
        ])}
        testId="location-nav-support-dashboard"
      />

      <NavigationSideItem
        text="Alerts Dash"
        url="/dashboard/alerts"
        matchUrl="/alerts"
        icon={viAlert}
        show={user.can('alert.view')}
        testId="location-nav-alerts-dash"
      />

      <NavigationSideItem
        text="Excluded Locations"
        url="/dashboard/excluded"
        matchUrl="/excluded"
        icon={viCloseCircle}
        show={user.can('alert.view')}
        testId="location-nav-excluded-locations"
      />

    </NavigationSide>
  );
}

function mapStateToProps(state) {
  return {
    user: state.login.user,
  };
}

export default connect(mapStateToProps)(LocationNavigation);
